import type { ReactNode } from 'react';
import { StyleSheet, View } from 'react-native';
import type { StyleProp, ViewStyle } from 'react-native';

import { useTheme } from '../theme/ThemeProvider';

export type DataPanelRowProps = {
  children?: ReactNode;
  style?: StyleProp<ViewStyle>;
  testID?: string;
};

export function DataPanelRow({ children, style, testID }: DataPanelRowProps) {
  const theme = useTheme();

  return (
    <View testID={testID} style={[styles.row, { gap: theme.spacing(1) }, style]}>
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  row: { flexDirection: 'row', alignItems: 'stretch' },
});
